import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Lightweight OAuth callback page.
 * Composio redirects the popup here after OAuth completes.
 * This page posts a message to the parent window and closes itself.
 */
export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const connected = searchParams.get('connected') || '';

  useEffect(() => {
    // Post message to the parent (opener) window
    if (window.opener) {
      window.opener.postMessage(
        { type: 'composio_oauth_complete', slug: connected },
        window.location.origin
      );
    }

    // Auto-close after a brief delay so user sees the success state
    const timer = setTimeout(() => {
      window.close();
    }, 1200);

    return () => clearTimeout(timer);
  }, [connected]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#131A26',
      color: '#F0F4F8',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        width: 48,
        height: 48,
        borderRadius: '50%',
        background: 'rgba(0,229,192,0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 16,
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00E5C0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <p style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>
        Connected successfully
      </p>
      <p style={{ fontSize: 13, color: '#7D8896', marginTop: 6 }}>
        This window will close automatically...
      </p>
    </div>
  );
}
